export default __webpack_public_path__ + "static/media/benefit_4@3x.d4a35b4a.png";